import React, { useState } from 'react';
import { Form } from 'antd';
import { notification } from '@gamesb42/ui-kit';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';

import { setPasswordWithCode } from 'api/users';
import urls from 'constants/urls';
import { ResetPasswordForm, ExpiredLinkScreen } from './components';
import Slider from '../LogIn/components/Slider';

import s from '../LogIn/styles.module.scss';

interface ResetPasswordFormData {
  password: string;
  confirmPassword: string;
}

export default function ResetPassword() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isLinkExpired, setIsLinkExpired] = useState(false);
  const history = useHistory();
  const location = useLocation();

  // Извлекаем code из query параметров
  const { code } = queryString.parse(location.search);

  const onFinish = async (values: ResetPasswordFormData) => {
    if (!code || typeof code !== 'string') {
      notification.error({
        theme: 'dark',
        message: 'Invalid Link',
        description: 'Invalid reset link. Please request a new password reset link.',
        placement: 'bottomLeft',
      });
      return;
    }

    setLoading(true);
    try {
      await setPasswordWithCode({
        code: code as string,
        password: values.password,
      });

      notification.success({
        theme: 'dark',
        message: 'Password Set Successfully',
        description: 'Your password has been set successfully!',
        placement: 'bottomLeft',
      });

      // Редирект на страницу логина
      history.push(urls.getAuth());
    } catch (error: any) {
      console.error('Set password error:', error);
      console.log('Error message:', error.message);

      // Проверяем, является ли ошибка "Confirmation Code already used"
      try {
        const errorData = JSON.parse(error.message);
        console.log('Parsed error data:', errorData);

        // Проверяем разные форматы ошибок
        const isCodeExpired =
          // Формат: {"errors": ["Confirmation Code already used"]}
          errorData?.errors?.[0] === 'Confirmation Code already used' ||
          // Формат: {"errors": [["Confirmation Code already used"]]}
          errorData?.errors?.[0]?.[0] === 'Confirmation Code already used' ||
          // Формат: {"errors": [[{msg: "..."}]]}
          errorData?.errors?.[0]?.[0]?.msg === 'Confirmation Code already used' ||
          // Формат: {"detail": [{msg: "..."}]}
          errorData?.detail?.some?.((d: any) => d.msg === 'Confirmation Code already used') ||
          // Проверяем если errors это массив строк и содержит нужный текст
          (Array.isArray(errorData?.errors) && errorData.errors.includes('Confirmation Code already used'));

        console.log('Is code expired:', isCodeExpired);

        if (isCodeExpired) {
          setIsLinkExpired(true);
          return;
        }
      } catch (parseError) {
        console.error('Error parsing error data:', parseError);
      }

      notification.error({
        theme: 'dark',
        message: 'Failed to Set Password',
        description: 'Failed to set password. The link may have expired. Please request a new link.',
        placement: 'bottomLeft',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={s.root}>
      <div className={s.block} style={{ width: '50%', height: '100vh' }}>
        <Slider />
      </div>
      <div
        className={s.block}
        style={{ padding: '0 70px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <div style={{ width: '452px' }}>
          {isLinkExpired ? (
            <ExpiredLinkScreen />
          ) : (
            <ResetPasswordForm form={form} loading={loading} onFinish={onFinish} />
          )}
        </div>
      </div>
    </div>
  );
}
